import { useApi } from '@core/http/useApi';
import { applicationPaths } from '@core/http/applicationPaths';
import { CreateEditPMZoneRequest } from './CreateEditZoneForm.utils';

export const useFormSubmit = (id?: number, createForm?: boolean) => {
  const url = createForm ? applicationPaths.pmZones.addPMZone : applicationPaths.pmZones.editPMZone({ id });

  const [sendFormData, , submittingForm, submitError] = useApi<number, CreateEditPMZoneRequest>(
    url,
    createForm ? 'post' : 'put'
  );

  return { sendFormData, submittingForm, submitError };
};
